import styled from 'styled-components'
import tw from 'twin.macro'

export const AuthorSection = styled.div`
  ${tw`bg-grey__light flex flex-col items-center p-2 max-w-full md:items-start md:flex-row`}
`
